import { AlarmControl } from '../alarm-control';
import { ControlBuilder } from './control.builder';
import { isArray } from 'util';
import { AlarmActionBuilder } from './alarm-action.builder';

export class AlarmControlBuilder {
  static fromJson(json) {
    return (json)
      ? new AlarmControl(
        json.hash,
        json.description,
        json.alarmTxt,
        AlarmActionBuilder.fromJson(json.action),
        ControlBuilder.fromJson(json.control)
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(AlarmControlBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/alarm-control.builder.ts